// set app detail info type
export const SET_APP_DETAIL = 'SET_APP_DETAIL'
// push stack type
export const PUSH_APP_STACK = 'PUSH_APP_STACK'
// pop stack type
export const POP_APP_STACK = 'POP_APP_STACK'
